/** Co-parenting HQ design tokens. Used for JSON-LD / docs; Tailwind `hq-*` is source of truth. */
export const HQ_THEME = {
  cream: '#F6F1E8',
  ink: '#1C1917',
  muted: '#5C564F',
  body: '#3F3A35',
  sage: '#3F6F5B',
  sageHover: '#345C4B',
  paper: '#FFFFFF',
  border: '#E4DDD0',
  borderStrong: '#D9D1C4',
  success: '#E8EFEA',
  error: '#9B3D1F',
  legal: '#8A847C',
  harbor: '#018B9C',
  harborInk: '#015461',
  harborSoft: '#E6F4F6',
} as const;

export const HQ_SHELL = 'mx-auto w-full max-w-6xl px-4 sm:px-6';
export const HQ_ARTICLE = 'mx-auto w-full max-w-2xl';
